"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTree = void 0;
require("core-js/modules/es.symbol.description.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const updateTree = exports.updateTree = function updateTree(items, position) {
  let level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return items.map((item, index) => {
    if (level === position.length - 1) {
      // At the target level: open only the clicked item, close others
      return _objectSpread(_objectSpread({}, item), {}, {
        isOpen: index === position[level] ? !item.isOpen : false
      });
    }
    if (index === position[level] && item.menuItems) {
      // Go deeper into the tree
      return _objectSpread(_objectSpread({}, item), {}, {
        isOpen: true,
        menuItems: updateTree(item.menuItems, position, level + 1)
      });
    }
    // Close all other branches
    return _objectSpread(_objectSpread({}, item), {}, {
      isOpen: false
    });
  });
};